import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-brand-offer',
  templateUrl: './brand-offer.component.html',
  styleUrls: ['./brand-offer.component.scss']
})
export class BrandOfferComponent implements OnInit {
  @Input() offer;

  constructor(
    private router: Router
  ) { }

  ngOnInit(): void {

  }

  goToOfferDetails(id) {
    this.router.navigate(['brand-offer', id],{
      queryParams:{
        isPlus: this.offer.plus
      }
    })
  }
}
